document.addEventListener("DOMContentLoaded", function () {
	const form = document.querySelector(".js-restoration-form");
	if (!form) return;

	// Error messages
	const errorMsgs = FoxTheme.contactStrings;

	// Get shadow form ID from data attribute
	const shadowFormId = form.getAttribute("data-shadow-form-id");

	// Hide the shadow form for restoration
	function hideShadowForm() {
		document.querySelectorAll(`div[data-forms-id="forms-root-${shadowFormId}"]`).forEach((div) => {
			if (div.closest(".section-app")) {
				div.closest(".section-app").style.display = "none";
			} else {
				div.style.display = "none";
			}
		});
	}
	hideShadowForm();

	// Utility to show error
	function showError(field, msg) {
		removeError(field);
		// For selects, place error outside .select for better display
		if (field.tagName === "SELECT") {
			let selectWrapper = field.closest(".select");
			let parent = selectWrapper ? selectWrapper.parentNode : field.parentNode;
			let span = parent.querySelector(".js-error-msg-select");
			if (!span) {
				span = document.createElement("span");
				span.className = "form-message form-message--error js-error-msg-select";
				span.style.color = "#E8083E";
				span.style.display = "block";
				span.style.marginTop = "0.2em";
				parent.appendChild(span);
			}
			span.innerText = msg;
			field.setAttribute("aria-invalid", "true");
		} else {
			let span = field.parentNode.querySelector(".js-error-msg");
			if (!span) {
				span = document.createElement("span");
				span.className = "form-message form-message--error js-error-msg";
				span.style.color = "#E8083E";
				span.style.display = "block";
				span.style.marginTop = "0.2em";
				field.parentNode.appendChild(span);
			}
			span.innerText = msg;
			field.setAttribute("aria-invalid", "true");
		}
	}
	function removeError(field) {
		field.removeAttribute("aria-invalid");
		// Remove select error
		if (field.tagName === "SELECT") {
			let selectWrapper = field.closest(".select");
			let parent = selectWrapper ? selectWrapper.parentNode : field.parentNode;
			const err = parent.querySelector(".js-error-msg-select");
			if (err) err.remove();
		}
		// Remove normal error
		const err = field.parentNode.querySelector(".js-error-msg");
		if (err) err.remove();
	}

	// Validate file input (max 3, png/jpeg)
	const fileInput = document.getElementById("restoration-file-upload");
	const fileNameSpan = document.getElementById("restoration-file-name");
	if (fileInput && fileNameSpan) {
		fileInput.addEventListener("change", () => {
			let errorSpan = fileNameSpan.parentNode.querySelector(".js-file-error");
			if (errorSpan) errorSpan.remove();
			const files = Array.from(fileInput.files);
			if (files.length > 3) {
				fileInput.value = "";
				fileNameSpan.textContent = errorMsgs.attachments;
				let err = document.createElement("span");
				err.className = "form-message form-message--error js-file-error";
				err.style.color = "#E8083E";
				err.style.display = "block";
				err.style.marginTop = "0.2em";
				err.textContent = errorMsgs.fileInputError;
				fileNameSpan.parentNode.appendChild(err);
				return;
			}
			const invalidFile = files.find((f) => !/^image\/(jpeg|png)$/.test(f.type));
			if (invalidFile) {
				fileInput.value = "";
				fileNameSpan.textContent = errorMsgs.attachments;
				let err = document.createElement("span");
				err.className = "form-message form-message--error js-file-error";
				err.style.color = "#E8083E";
				err.style.display = "block";
				err.style.marginTop = "0.2em";
				err.textContent = errorMsgs.fileInputTypeError;
				fileNameSpan.parentNode.appendChild(err);
				return;
			}
			if (files.length > 0) {
				fileNameSpan.textContent = files.map((file) => file.name).join(", ");
			} else {
				fileNameSpan.textContent = errorMsgs.attachments;
			}
		});
	}

	// Main fields
	const mainFields = {
		firstName: form.querySelector('[name="restoration[first_name]"]'),
		lastName: form.querySelector('[name="restoration[last_name]"]'),
		email: form.querySelector('[name="restoration[email]"]'),
		confirmEmail: form.querySelector('[name="restoration[confirm_email]"]'),
		country: form.querySelector('[name="restoration[residence_country]"]'),
		purchasePlace: form.querySelector('[name="restoration[purchase_place]"]'),
		message: form.querySelector('[name="restoration[repair_message ]"]'),
	};

	// Track if submit has been attempted
	let submitAttempted = false;

	// Validate a single field
	function validateField(field) {
		if (!field.required) {
			removeError(field);
			return true;
		}
		// Email format validation
		if ((field === mainFields.email || field === mainFields.confirmEmail) && field.value.trim()) {
			const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
			if (!emailPattern.test(field.value.trim())) {
				showError(field, errorMsgs.emailFormat || "Format d'email invalide");
				return false;
			}
		}
		if (field.tagName === "SELECT") {
			if (!field.value || field.options[field.selectedIndex].disabled) {
				if (field === mainFields.country) showError(field, errorMsgs.country);
				else if (field === mainFields.purchasePlace) showError(field, errorMsgs.purchaseLocation);
				return false;
			}
		}
		if (!field.value.trim()) {
			if (field === mainFields.firstName) showError(field, errorMsgs.firstName);
			else if (field === mainFields.lastName) showError(field, errorMsgs.lastName);
			else if (field === mainFields.email) showError(field, errorMsgs.email);
			else if (field === mainFields.confirmEmail) showError(field, errorMsgs.confirmEmail);
			else if (field === mainFields.country) showError(field, errorMsgs.country);
			else if (field === mainFields.purchasePlace) showError(field, errorMsgs.purchaseLocation);
			else if (field === mainFields.message) showError(field, errorMsgs.message);
			return false;
		}
		removeError(field);
		return true;
	}

	// Validate emails match, prioritize format, show errors only on submit
	function validateEmailsMatch() {
		const email = mainFields.email.value.trim();
		const confirm = mainFields.confirmEmail.value.trim();
		let valid = true;
		const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
		let emailValid = true;
		let confirmValid = true;

		if (!email) {
			showError(mainFields.email, errorMsgs.email);
			valid = false;
			emailValid = false;
		} else if (!emailPattern.test(email)) {
			showError(mainFields.email, errorMsgs.emailFormat || "Format d'email invalide");
			valid = false;
			emailValid = false;
		}

		if (!confirm) {
			showError(mainFields.confirmEmail, errorMsgs.confirmEmail);
			valid = false;
			confirmValid = false;
		} else if (!emailPattern.test(confirm)) {
			showError(mainFields.confirmEmail, errorMsgs.emailFormat || "Format d'email invalide");
			valid = false;
			confirmValid = false;
		}

		if (emailValid && confirmValid) {
			if (email !== confirm) {
				if (submitAttempted) {
					showError(mainFields.email, errorMsgs.emailMatch);
					showError(mainFields.confirmEmail, errorMsgs.emailMatch);
				} else {
					removeError(mainFields.email);
					removeError(mainFields.confirmEmail);
				}
				valid = false;
			} else {
				removeError(mainFields.email);
				removeError(mainFields.confirmEmail);
			}
		}
		return valid;
	}

	// Attach validation events (only remove error on input, never show error unless submitAttempted)
	Object.values(mainFields).forEach((field) => {
		if (!field) return;
		field.addEventListener("input", () => {
			if (submitAttempted) {
				validateField(field);
				if (field === mainFields.email || field === mainFields.confirmEmail) validateEmailsMatch();
			} else {
				removeError(field);
			}
		});
	});

	// Ajout : auto-formatage du champ purchase_date (jj/mm/aaaa)
	const purchaseDateInput = document.querySelector('[name="restoration[purchase_date]"]');
	if (purchaseDateInput) {
		purchaseDateInput.addEventListener("input", function (e) {
			let value = purchaseDateInput.value.replace(/\D/g, ""); // Retirer tout sauf chiffres
			if (value.length > 8) value = value.slice(0, 8);
			let formatted = "";
			if (value.length > 4) {
				formatted = value.slice(0, 2) + "/" + value.slice(2, 4) + "/" + value.slice(4);
			} else if (value.length > 2) {
				formatted = value.slice(0, 2) + "/" + value.slice(2);
			} else {
				formatted = value;
			}
			purchaseDateInput.value = formatted;
		});
	}

	// On submit: validate all
	const submitBtn = form.querySelector(".js-restoration-submit");
	if (submitBtn) {
		submitBtn.addEventListener("click", function (e) {
			e.preventDefault();
			submitAttempted = true;
			let valid = true;
			form.querySelectorAll("input[required], textarea[required], select[required]").forEach((field) => {
				if (!validateField(field)) valid = false;
			});
			if (!validateEmailsMatch()) valid = false;
			// Validate file input
			if (fileInput && fileInput.files.length > 3) valid = false;
			if (fileInput && Array.from(fileInput.files).find((f) => !/^image\/(jpeg|png)$/.test(f.type))) valid = false;
			if (!valid) return;

			// Inject values into shadow form (for embedded apps)
			const SEPARATOR = "|||";
			const fieldNodes = form.querySelectorAll("input, textarea, select");
			let contentArr = [];
			let emailValue = "";

			const langValue = document.querySelector(".contact-form__wrapper")?.getAttribute("data-lang") || "";
			// Add language as a field in the content array
			if (langValue) {
				contentArr.push("lang: " + langValue);
			}

			fieldNodes.forEach((node) => {
				if (node.type === "file" || !node.name || node.offsetParent === null) return;
				if (node.name === "restoration[email]") {
					emailValue = node.value;
					return;
				}
				if (node.name === "restoration[confirm_email]") return;
				let label = "";
				// const labelEl = form.querySelector('label[for="' + node.id + '"]');
				// label = label.replace("(" + errorMsgs.optional + ")", "");
				// label = labelEl ? labelEl.innerText.trim() : node.name.replace(/^restoration\[|\]$/g, "").replace(/_/g, " ");
				label = node.name.replace(/^restoration\[|\]$/g, "");
				let value =
					node.type === "checkbox" || node.type === "radio"
						? node.checked
							? node.value
							: ""
						: node.tagName.toLowerCase() === "select" && !node.multiple
							? node.options[node.selectedIndex]?.text || ""
							: node.tagName.toLowerCase() === "select" && node.multiple
								? Array.from(node.selectedOptions)
										.map((opt) => opt.text)
										.join(", ")
								: node.value;
				if (value) contentArr.push(label + ": " + value);
			});

			const host = document.querySelector("#app-embed");
			const root = host?.shadowRoot;
			if (root) {
				const shadowEmail = root.querySelector("#email");
				if (shadowEmail && emailValue) {
					shadowEmail.value = emailValue;
					shadowEmail.dispatchEvent(new Event("input", { bubbles: true }));
				}
				const shadowContent = root.querySelector("#custom\\#content");
				if (shadowContent) {
					shadowContent.value = contentArr.join(SEPARATOR);
					shadowContent.dispatchEvent(new Event("input", { bubbles: true }));
				}

				// Inject up to 3 files from the file input into the 3 shadow file fields
				if (fileInput) {
					const shadowFiles = [
						root.querySelector("#custom\\#file-field"),
						root.querySelector("#custom\\#file2-field"),
						root.querySelector("#custom\\#file3-field"),
					];
					const files = fileInput.files ? Array.from(fileInput.files) : [];
					for (let i = 0; i < 3; i++) {
						if (shadowFiles[i]) {
							if (files[i]) {
								const dt = new DataTransfer();
								dt.items.add(files[i]);
								shadowFiles[i].files = dt.files;
								shadowFiles[i].dispatchEvent(new Event("change", { bubbles: true }));
							} else {
								shadowFiles[i].value = "";
							}
						}
					}
				}

				const shadowForm = root.querySelector("form");
				if (shadowForm) shadowForm.requestSubmit ? shadowForm.requestSubmit() : shadowForm.submit();
			}

			// After successful submit, reload with ?restoration_posted=1 to show success message
			setTimeout(function () {
				const url = new URL(window.location.href);
				url.searchParams.set("restoration_posted", true);
				window.location.href = url.toString();
			}, 4000); // delay to allow shadow form to submit
		});
	}

	// On page load, show success message if param is present
	const params = new URLSearchParams(window.location.search);
	if (params.get("restoration_posted") == "true") {
		const formStatus = document.querySelector(".form-status-list");
		if (formStatus) {
			formStatus.style.display = "block";
			formStatus.scrollIntoView({ behavior: "smooth", block: "center" });
		}
	}
});
